import { useModals } from '@/contexts/ModalContext';
import { AppPromotionModal } from '@/modals/AppPromotionModal';
import { useCallback } from 'react';

export const useAppModal = () => {
  const { open } = useModals();

  const openAppPromotionModal = useCallback(() => {
    open('app-promotion-modal', <AppPromotionModal />, true);
  }, [open]);

  return openAppPromotionModal;
};
